module.exports = __webpack_public_path__ + "img/RUEDA_1.0d66eb06.png";